export const isExpectedFormat = (file: File, expectedFormats: string[]) =>
  expectedFormats.includes(file.name.split(".").pop() ?? "");
